module.exports = __webpack_public_path__ + "frontend/images/signpost/gold@2.jpg?90b1f67ec26665d6bd4733faf50facb6";